module.exports = __webpack_public_path__ + "static/img/8.4a99cb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/8.png
// module id = OPjI
// module chunks = 0